import { render, staticRenderFns } from "./EditInventory.vue?vue&type=template&id=dc028f4a"
import script from "./EditInventory.vue?vue&type=script&lang=js"
export * from "./EditInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports